import { ApplicationConfig, ErrorHandler, LOCALE_ID, APP_ID, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeNL from '@angular/common/locales/nl';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { NgxMatomoModule } from 'ngx-matomo-client';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { UpV1_BASE_URL, UpV1Service } from './core/services/UpV1Service.Generated';
import { AppService } from './core/services/app.service';
import { appHttpInterceptor } from './core/services/interceptor.service';
import { SpinnerService } from './core/spinner.service';
import { GlobalErrorHandlerService } from './global-error-handler.service';
import { AuthService } from './core/services/auth.service';
import { ToasterService } from './core/services/toaster/toaster.service';

registerLocaleData(localeNL);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

function authInitializer(authService: AuthService): () => Promise<void> {
  return () =>
    firstValueFrom(authService.isLoggedInObs()).then(loggedIn => {
      if (!loggedIn) {
        authService.login();
      }
    }).catch(() => authService.login());
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([appHttpInterceptor])),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    importProvidersFrom(
      MatSnackBarModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      NgxMatomoModule.forRoot(environment.matomoConfig)
    ),
    SpinnerService,
    ToasterService,
    UpV1Service,
    AppService,
    {
      provide: UpV1_BASE_URL,
      useValue: environment.UpV1BaseUrl
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    },
    {
      provide: LOCALE_ID,
      useValue: 'nl-NL'
    },
    { provide: APP_ID, useValue: 'ng-cli-universal' },
    {
      provide: APP_INITIALIZER,
      useFactory: authInitializer,
      deps: [AuthService],
      multi: true
    }
  ]
};
